import React, { useState } from 'react';
import { Mail, Linkedin, Twitter, Github, Users, Award, Briefcase, GraduationCap } from 'lucide-react';
import Navbar from '../../components/Navbar/Navbar';
import Emmanuel from "../../assets/editorial-team/emmanuel-adetiba.jpeg"
import boladele from "../../assets/editorial-team/boladele-akanle.png"
import Blessing from "../../assets/editorial-team/adekunle-blessing.jpg"
import Festus from "../../assets/editorial-team/festus-ojesanmin.jpeg"
import Priscilla from "../../assets/editorial-team/priscilla-ajay.jpeg"
import Joy from "../../assets/editorial-team/adetiba-joy.jpg"
import Olubanke from "../../assets/editorial-team/olubanke-ogunlana.jpg"
import uche from "../../assets/editorial-team/uche.jpg"
import faith from "../../assets/editorial-team/faith_nnaji.png"
import mercy from "../../assets/editorial-team/MBella-Omunagbe.jpg"



const EditorialTeam = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  // Principal Investigator
  const principalInvestigator = {
    id: 1,
    name: "Emmanuel Adetiba",
    title: "Prof.",
    role: "Editorial Lead & Principal Investigator",
    image: Emmanuel,
    bio: "Leading innovations in Artificial Intelligence(AI), Biomedical Signal Processing(BSP), Software Defined and Cognitive Radio (SDCR), Federated Cloud(FedCloud), High Performance Computing(HPC) and Internet of Things(IoT)  for more than two decades",
    color: "from-purple-600 via-indigo-600 to-blue-600"
  };

  // Core Implementation Team
  const coreTeam = [
    {
      id: 3,
      name: "Boladele Akanle",
      title: "Engr.",
      role: "Lead Infrastructure Engineer",
      image: boladele,
      bio: "Building robust systems for healthcare delivery",
      color: "from-green-500 to-teal-500"
    },
    {
      id: 4,
      name: "Priscilla Ajayi",
      title: "Mrs.",
      role: "Lead Software Engineer",
      image: Priscilla,
      bio: "Crafting elegant solutions for complex problems",
      color: "from-orange-500 to-red-500"
    },
    {
      id: 5,
      name: "Festus Ojesanmin",
      title: "Mr.",
      role: "DevOps Engineer",
      image: Festus,
      bio: "Streamlining deployment and operations",
      color: "from-indigo-500 to-purple-500"
    }
  ];

  // Co-Investigators
  const coInvestigators = [
    {
      id: 2,
      name: "Olubanke Ogunlana",
      title: "Prof.",
      role: "Lead Reviewer",
      image: Olubanke,
      bio: "Ensuring excellence through rigorous review processes",
      color: "from-blue-500 to-cyan-500"
    },
    {
      id: 6,
      name: "Ademola Adeyeye",
      title: "Dr.",
      credentials: "MBBS",
      role: "Reviewer",
      image: "/path-to-images/ademola-adeyeye.jpg",
      bio: "Providing clinical expertise and medical insight",
      color: "from-pink-500 to-rose-500"
    },
    {
      id: 7,
      name: "Joy N. Adetiba",
      title: "Mrs.",
      credentials: "MHSc",
      role: "Reviewer",
      image: Joy,
      bio: "Bridging research and practical health applications",
      color: "from-cyan-500 to-blue-500"
    }
  ];

  // Curation Team
  const curationTeam = [
    {
      id: 8,
      name: "Uche Nnaji",
      title: "Mr.",
      role: "Lead, Content Curation Team",
      image: uche,
      bio: "Curating quality content for public health education",
      color: "from-teal-500 to-green-500"
    },
    {
      id: 9,
      name: "Faith Nnaji",
      role: "Content Curation Intern",
      image: faith,
      bio: "Fresh perspectives in health communication",
      color: "from-amber-500 to-orange-500"
    },
    {
      id: 10,
      name: "Mercy Bella-Omunagbe",
      role: "Content Curation Intern",
      image: mercy,
      bio: "Bringing creativity to health information",
      color: "from-violet-500 to-purple-500"
    }
  ];

  // Interns
  const interns = [
    {
      id: 11,
      name: "Blessing Adekunle",
      role: "Software Development Intern",
      image: Blessing,
      bio: "Building the future of health tech",
      color: "from-fuchsia-500 to-pink-500"
    }
  ];

  const getInitials = (name) => {
    const parts = name.split(' ');
    return parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : name.substring(0, 2);
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50">
        
        {/* Hero Section with Animation */}
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-teal-400 via-blue-500 to-indigo-600 opacity-90"></div>
          <div className="absolute inset-0 bg-black opacity-10"></div>
          
          {/* Animated Background Circles */}
          <div className="absolute top-20 left-10 w-72 h-72 bg-white opacity-10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-20 w-96 h-96 bg-purple-300 opacity-10 rounded-full blur-3xl animate-pulse delay-700"></div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
            <div className="text-center">
              <h1 className="text-5xl lg:text-6xl font-extrabold text-white text-center mb-6 tracking-tight">
                Meet the Team
              </h1>
              <p className="text-xl lg:text-2xl text-white/95 max-w-3xl mx-auto font-light">
                Brilliant minds working together to revolutionize public health information systems
              </p>
            </div>
          </div>
        </div>

        {/* Principal Investigator - Featured */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20 relative z-10">
          <div className="max-w-4xl mx-auto">
            <LeadCard 
              member={principalInvestigator} 
              getInitials={getInitials}
              isHovered={hoveredCard === principalInvestigator.id}
              onHover={() => setHoveredCard(principalInvestigator.id)}
              onLeave={() => setHoveredCard(null)}
            />
          </div>
        </div>

        {/* Core Implementation Team */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <SectionHeader 
            // icon={<Briefcase className="w-8 h-8" />}
            title="Core Implementation Team"
            // subtitle="Expert engineers building the backbone of FEDGEN-PHIS"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 mt-12">
            {coreTeam.map((member, index) => (
              <TeamCard 
                key={member.id} 
                member={member} 
                getInitials={getInitials}
                isHovered={hoveredCard === member.id}
                onHover={() => setHoveredCard(member.id)}
                onLeave={() => setHoveredCard(null)}
                delay={index * 50}
              />
            ))}
          </div>
        </div>

        {/* Co-Investigators */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <SectionHeader 
            // icon={<Award className="w-8 h-8" />}
            title="Co-Investigators"
            // subtitle="Academic and clinical experts ensuring research excellence"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 mt-12">
            {coInvestigators.map((member, index) => (
              <TeamCard 
                key={member.id} 
                member={member} 
                getInitials={getInitials}
                isHovered={hoveredCard === member.id}
                onHover={() => setHoveredCard(member.id)}
                onLeave={() => setHoveredCard(null)}
                delay={index * 50}
              />
            ))}
          </div>
        </div>

        {/* Curation Team */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <SectionHeader
            // icon={<Users className="w-8 h-8" />}
            title="Curation Team"
            // subtitle="Partners helping us achieve our mission"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 mt-12">
            {curationTeam.map((member, index) => (
              <TeamCard 
                key={member.id} 
                member={member} 
                getInitials={getInitials}
                isHovered={hoveredCard === member.id}
                onHover={() => setHoveredCard(member.id)}
                onLeave={() => setHoveredCard(null)}
                delay={index * 50}
              />
            ))}
          </div>
        </div>

        {/* Interns */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <SectionHeader 
            // icon={<GraduationCap className="w-8 h-8" />}
            title="Interns"
            // subtitle="Rising stars contributing fresh ideas and energy"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 mt-12">
            {interns.map((member, index) => (
              <TeamCard 
                key={member.id} 
                member={member} 
                getInitials={getInitials}
                isHovered={hoveredCard === member.id}
                onHover={() => setHoveredCard(member.id)}
                onLeave={() => setHoveredCard(null)}
                delay={index * 50}
              />
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="relative overflow-hidden bg-blue-600  py-16 lg:py-20">
          <div className="absolute inset-0 bg-black opacity-10"></div>
          <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Want to Work With Us?
            </h2>
            <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              We're always looking for talented individuals passionate about making a difference in public health
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:info@fedgen.net"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-indigo-600 rounded-full font-semibold hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 shadow-xl"
              >
                <Mail className="w-5 h-5 mr-2" />
                Get in Touch
              </a>
              <a
                href="/guidelines"
                className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold hover:bg-white/20 transform hover:scale-105 transition-all duration-300 border-2 border-white/50"
              >
                View Guidelines
              </a>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

// Section Header Component
const SectionHeader = ({ icon, title, subtitle }) => (
  <div className="text-center mb-8">
    {/* <div className="flex items-center justify-center mb-4">
      <div className="p-3 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl text-white shadow-lg">
        {icon}
      </div>
    </div> */}
    <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
      {title}
    </h2>
    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
      {subtitle}
    </p>
  </div>
);

// Lead Card Component (Larger, Featured Card for PI)
const LeadCard = ({ member, getInitials, isHovered, onHover, onLeave }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div 
      className="group relative"
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 transition-all duration-500">
        
        {/* Card Background Gradient Overlay */}
        <div className={`absolute inset-0 bg-gradient-to-br ${member.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
        
        <div className="flex flex-col md:flex-row">
          {/* Image/Avatar Section */}
          <div className="relative md:w-1/2 h-80 md:h-auto overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
            <div className={`absolute inset-0 bg-gradient-to-br ${member.color} opacity-30`}></div>
            
            {!imageError ? (
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br ${member.color}`}>
                <span className="text-8xl font-bold text-white">
                  {getInitials(member.name)}
                </span>
              </div>
            )}
            
            {/* Floating Badge */}
            <div className="absolute top-6 right-6 px-5 py-2 bg-white/95 backdrop-blur-sm rounded-full text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 shadow-xl">
              Principal Investigator
            </div>
          </div>

          {/* Content Section */}
          <div className="md:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
            <div className="mb-6">
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors">
                {member.title && <span className="text-lg font-normal text-gray-500 mr-2">{member.title}</span>}
                {member.name}
              </h3>
              <p className="text-lg font-semibold text-indigo-600 mb-4">
                {member.role}
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                {member.bio}
              </p>
            </div>

            {/* Social Links */}
            {/* <div className="flex gap-3">
              <button className="p-3 bg-gray-100 rounded-full hover:bg-indigo-100 hover:text-indigo-600 transition-colors">
                <Mail className="w-5 h-5" />
              </button>
              <button className="p-3 bg-gray-100 rounded-full hover:bg-blue-100 hover:text-blue-600 transition-colors">
                <Linkedin className="w-5 h-5" />
              </button>
            </div> */}
          </div>
        </div>

        {/* Bottom Accent Line */}
        <div className={`h-2 bg-gradient-to-r ${member.color}`}></div>
      </div>
    </div>
  );
};

// Enhanced Team Card Component
const TeamCard = ({ member, getInitials, isHovered, onHover, onLeave, delay }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div 
      className="group relative"
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500">
        
        {/* Card Background Gradient Overlay */}
        <div className={`absolute inset-0 bg-gradient-to-br ${member.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
        
        {/* Image/Avatar Section */}
        <div className="relative h-64 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
          <div className={`absolute inset-0 bg-gradient-to-br ${member.color} opacity-20`}></div>
          
          {!imageError ? (
            <img
              src={member.image}
              alt={member.name}
              className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br ${member.color}`}>
              <span className="text-6xl font-bold text-white">
                {getInitials(member.name)}
              </span>
            </div>
          )}
          
          {/* Floating Badge */}
          <div className="absolute top-4 right-4 px-4 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-semibold text-gray-700 shadow-lg">
            {member.role.split(' ')[0]}
          </div>
        </div>

        {/* Content Section */}
        <div className="p-6">
          <div className="mb-3">
            <h3 className="text-xl font-bold text-gray-900 mb-1 group-hover:text-indigo-600 transition-colors">
              {member.title && <span className="text-sm font-normal text-gray-500 mr-1">{member.title}</span>}
              {member.name}
              {member.credentials && <span className="text-sm font-normal text-gray-500 ml-1">, {member.credentials}</span>}
            </h3>
            <p className="text-sm font-medium text-indigo-600">
              {member.role}
            </p>
          </div>
          
          <p className="text-sm text-gray-600 leading-relaxed mb-4">
            {member.bio}
          </p>

          {/* Social Links - Hidden by default, shown on hover */}
          {/* <div className="flex gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <button className="p-2 bg-gray-100 rounded-full hover:bg-indigo-100 hover:text-indigo-600 transition-colors">
              <Mail className="w-4 h-4" />
            </button>
            <button className="p-2 bg-gray-100 rounded-full hover:bg-blue-100 hover:text-blue-600 transition-colors">
              <Linkedin className="w-4 h-4" />
            </button>
          </div> */}
        </div>

        {/* Bottom Accent Line */}
        <div className={`h-1 bg-gradient-to-r ${member.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
      </div>
    </div>
  );
};

export default EditorialTeam;